module.exports = __webpack_public_path__ + "media/summer_2023_sweepstakes/instagram-2c8383e4.svg";